export default __webpack_public_path__ + "assets/webgl/complete-8.9e71abfa.jpg";